
const CollectionName = "publicSettings";

let unsubscribeMinVersion;

export async function listenToMinVersion(onSnapshot) {
  if (unsubscribeMinVersion) {
    await db.removeListener(unsubscribeMinVersion)
  }
  unsubscribeMinVersion = await db.listenToDocument(CollectionName, "version", onSnapshot)
}

export async function getRemoteLoadingCode(onSnapshot) {
   const doc = await db.getDocument(CollectionName, "cordova");
   return doc.remoteLoadingCode;
}


export async function contact(contact) {
  await db.callable("contact", contact);
}

